import { useRef, useState } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { FormikAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { SUCURSAL_ORIGEN } from 'Constants'
import es from 'date-fns/locale/es'
import { Form, Formik } from 'formik'
import { interfaces } from 'service/interfaces'

const ExportOrders = (props) => {
  const { onClose, open, data } = props
  const createDismissableSnackbar = useCustomSnackbar()
  const [loading, setLoading] = useState(false)

  const ref = useRef(null)

  const handleSubmit = () => {
    ref.current.click()
  }

  const options = [
    {
      id: 1,
      optionLabel: 'NO',
    },
    {
      id: 2,
      optionLabel: 'SI',
    },
  ]
  const TRIMESTRE = [
    {
      optionLabel: 'Enero a Marzo',
    },
    {
      optionLabel: 'Abril a Junio',
    },
    {
      optionLabel: 'Julio a Septiembre',
    },
    {
      optionLabel: 'Octubre a Diciembre',
    },
    {
      optionLabel: 'TODOS',
    },
  ]

  async function onSubmit(values) {
    setLoading(true)
    await interfaces.salesOrders
      .exportOrders(values)
      .then((res) => {
        window.location.assign(res.data)
        createDismissableSnackbar('Pedidos exportados!', {
          variant: 'success',
        })
        onClose()
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal!', {
          variant: 'error',
        })
      })
    setLoading(false)
  }

  const fields = (setFieldValue, values) => [
    {
      class: 'custom',
      sm: 6,
      xs: 12,
      component: (
        <FormikAutocomplete
          defaultValue={{ id: 1, label: 'ECO' }}
          label="Origen"
          name="origen"
          options={SUCURSAL_ORIGEN}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('origen', value.label)
          }}
        />
      ),
    },
    {
      class: 'custom',
      sm: 6,
      xs: 12,
      component: (
        <FormikAutocomplete
          label="Usuario"
          name="usuario"
          options={data.usuarios}
          getOptionLabel={(e) => e.fullName}
          onChange={(_, value) => {
            setFieldValue('usuario', value.fullName)
          }}
        />
      ),
    },
    {
      class: 'custom',
      sm: 6,
      xs: 12,
      component: (
        <FormikAutocomplete
          label="Sucursal"
          name="sucursal"
          options={data.sucursal}
          getOptionLabel={(e) => e.nombre}
          onChange={(_, value) => {
            setFieldValue('sucursal', value.nombre)
          }}
        />
      ),
    },
    {
      class: 'custom',
      sm: 6,
      xs: 12,
      component: (
        <FormikAutocomplete
          defaultValue={{ id: 1, optionLabel: 'NO' }}
          label="Comprobante generado"
          name="facturado"
          options={options}
          getOptionLabel={(e) => e.optionLabel}
          onChange={(_, value) => {
            setFieldValue('facturado', value.optionLabel)
          }}
        />
      ),
    },
    {
      class: 'custom',
      sm: 6,
      xs: 12,
      component: (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            inputVariant="outlined"
            format="yyyy"
            PopoverProps={{ style: { ...{ left: '40px' } } }}
            fullWidth
            views={['year']}
            label="Año"
            name="año"
            value={new Date(values.año, 0)}
            onChange={(date) => {
              setFieldValue('año', date ? date.getFullYear() : '')
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{ style: { marginBottom: '19px' } }}
          />
        </MuiPickersUtilsProvider>
      ),
    },
    {
      class: 'custom',
      sm: 6,
      xs: 12,
      component: (
        <FormikAutocomplete
          defaultValue={{ optionLabel: 'TODOS' }}
          label="Trimestre"
          name="trimestre"
          options={TRIMESTRE}
          getOptionLabel={(e) => e.optionLabel}
          onChange={(_, value) => {
            setFieldValue('trimestre', value.optionLabel)
          }}
        />
      ),
    },
  ]

  return (
    <DialogComponent
      open={open}
      handleclose={onClose}
      title="Exportar pedidos"
      disableBackdropClick={true}
      handleclosedisabled={loading}
      disableChildHeight
      disableEscapeKeyDown
      widthLarge="500px"
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={onClose}
          disabledCancel={loading}
          disabledSubmit={loading}
          isLoading={loading}
          submitText="Descargar"
        />
      }
      children={
        <Formik
          initialValues={{
            origen: 1,
            usuario: 'TODOS',
            sucursal: null,
            facturado: 'NO',
            año: 2025,
            trimestre: 'TODOS',
          }}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ setFieldValue, values }) => (
            <Form>
              <InputsWithValidate
                fields={fields(setFieldValue, values)}
                spacing={1}
                setFieldValue={setFieldValue}
              />
              <button style={{ display: 'none' }} ref={ref} type="submit" />
            </Form>
          )}
        </Formik>
      }
    />
  )
}

export default ExportOrders
